import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import Recaptcha from 'react-recaptcha';
import { useSelector } from 'react-redux';

import { selectIsWebLinkDistribution } from 'selector/distributionSelector';
import { selectRecaptchaKey } from 'selector/apiSelector';
import { useRecaptchaTokenAtom } from 'shared/hooks/useAtoms';
import { loadRecaptchaScript } from 'shared/utils/loadRecaptchaScript';

export type WithRecaptchaProps = {
  children: React.ReactNode;
};

export const WithRecaptcha: React.VFC<WithRecaptchaProps> = ({ children }) => {
  const recaptchaInstance = useRef<Recaptcha>();

  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const isWebLinkDistribution = useSelector(selectIsWebLinkDistribution);
  const recaptchaSiteKey = selectRecaptchaKey();
  const [, setRecaptchaToken] = useRecaptchaTokenAtom();
  const shouldRenderRecaptcha = isWebLinkDistribution && Boolean(recaptchaSiteKey);

  // react-recaptcha polls window.grecaptcha, so injecting the script lazily here is enough.
  useEffect(() => {
    if (shouldRenderRecaptcha) {
      loadRecaptchaScript();
    }
  }, [shouldRenderRecaptcha]);

  useEffect(() => {
    if (isLoaded) {
      recaptchaInstance.current.execute();
    }
  }, [isLoaded]);

  return (
    <div>
      {(isLoaded || !shouldRenderRecaptcha) && children}
      {shouldRenderRecaptcha && (
        <Recaptcha
          ref={(ref) => (recaptchaInstance.current = ref)}
          sitekey={recaptchaSiteKey}
          render="explicit"
          size="invisible"
          onloadCallback={() => setIsLoaded(true)}
          verifyCallback={setRecaptchaToken}
        />
      )}
    </div>
  );
};
